export default __webpack_public_path__ + "static/media/project-zg.788814c2.png";